import { Component, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Router } from 'express';
import { loadVideos } from '../../action/video.actions';
import { DynamicLandingpageComponent } from '../../landingpages/dynamic-landingpage/dynamic-landingpage.component';

@Component({
  selector: 'app-video-details',
  templateUrl: './video-details.component.html',
  styleUrl: './video-details.component.scss'
})
export class VideoDetailsComponent implements OnInit{
  video: any;
  videoUrl: any;
  constructor(private route: ActivatedRoute,private store: Store<any>,private sanitizer: DomSanitizer,
    private titleService:Title,private meta:Meta,private renderer: Renderer2,private dialog:MatDialog
  ){
        this.store.dispatch(loadVideos());

    }

  tempVideo:any=
    {
      id: 12,
      title: 'Streamline Your Pharmacy Operations with MedeilCloud POS',
      description: 'Discover how MedeilCloud POS can help you manage your pharmacy operations more efficiently. Our cloud-based point of sale system is designed to streamline your workflow, reduce errors, and improve customer satisfaction. Watch this video to learn more about the benefits of MedeilCloud POS and how it can help you grow your pharmacy business',
      category: '2',
      publishdate: '2025-02-27',
      videolink: 'https://www.youtube.com/embed/2M72Mdy8vOg',
      status: 0,
      keywords: 'Pharmacy POS system, Cloud-based POS, Point of sale system for pharmacies, Streamline pharmacy operations, Pharmacy management system',
      keywords1: '',
      seotitle: 'Pharmacy POS System | MedeilCloud POS - Streamline Your Operations',
      seodescription: 'MedeilCloud POS is a cloud-based point of sale system designed for pharmacies. Our system helps streamline operations, reduce errors, and improve customer satis',
      more_description: null,
      seo_url: null,
      cta_button_enabled: false,
      togglecontrol: false,
      cta_button_text: null,
      cta_button_link: null,
      cta_button_source_name: null
    }

  ngOnInit() {
    const title = this.route.snapshot.paramMap.get('seoUrl');
    this.store.select((state:any)=>state.video).subscribe((data:any)=>{
      if(data){

        this.tempVideo=data.video.find(lp=>lp.seo_url==title)
        this.addVideoSchema();
        console.log('Received Page Data:', this.tempVideo);
        const rawUrl = "https://www.youtube.com/embed/2M72Mdy8vOg";
        this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.tempVideo.videolink);
        this.titleService.setTitle(this.tempVideo.seotitle);
        // Update meta tags
        this.meta.updateTag({ name: 'keywords', content: this.tempVideo.keywords });
        this.meta.updateTag({ name: 'description', content: this.tempVideo.seodescription });
      }
    })
  }
  addVideoSchema() {
    const schema = {
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": this.tempVideo.title,
      "description": this.tempVideo.seodescription,
      "uploadDate": this.tempVideo.publishdate,
      "contentUrl": this.tempVideo.videolink,
      "embedUrl": this.tempVideo.videolink,
      "publisher": {
        "@type": "Organization",
        "name": "Vanuston Intelligence Private Limited",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.medeil.com/en/assets/img/logo/Medeilicon1.png"
        }
      }
    };

    // Remove existing schema if present
    let existingSchema = document.getElementById('video-schema');
    if (existingSchema) {
      existingSchema.remove();
    }

    // Create new script tag
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'video-schema';
    script.text = JSON.stringify(schema);

    // Append to document head
    this.renderer.appendChild(document.head, script);
  }
   openLandingpage(leadsource:any){
        const dialogRef=this.dialog.open(DynamicLandingpageComponent,{
               width:'550px',
               data:leadsource

             })
             dialogRef.afterClosed().subscribe((data)=>{
               if(data){
                 console.log(data);
               }
             })
      }
}
